<template>
    <div class="form-block">
        <div>
            <h2 class="form-block__title mb-3">{{prop_titleform}}</h2>
            <div class="form-block_body">
                <div class="black_block d-flex flex-column">                    
                    <h5 data-v-576aef83="">Choose person to which will be merge current person:</h5>
                    <div data-v-576aef83="" class="input_search input_search_border mt-3">                                                
                        <input v-model="model_find" @keypress.enter="findname"  data-v-576aef83="" type="text" placeholder="Search" class="form-control"> 
                        <svg @click="findname" data-v-576aef83="" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path data-v-576aef83="" d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#9F9F9F"></path>
                        </svg>
                    </div>
                    <div v-for="(category, idx) in categories" :key="idx" >
                         <category-card-list
                            :category="category"                            
                        ></category-card-list>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-block__footer d-flex justify-content-between">
            <div class="form-block__footer_left d-flex justify-content-start align-items-end">                
            </div>
            <div class="form-block__footer_right d-flex justify-content-end align-items-end">
                <button @click="closePopup" class="btn btn-link">Cancel</button>                
                <button @click="mergePerson" class="btn btn-primary">Merge</button>
            </div>
        </div>
    </div>
</template>

<script>
import {bus} from '../../bus';
import axios from "axios";
import CategoryCardList from "../Categories/CategoryCardList";

export default {
    props: [
        'prop_titleform', 
        'category_id', 
        'person', 
        'crud'
    ],
    data(){
        return{
            title_form: '',
            model_person: {
                faces: [],
                first_name: '',
                last_name: '',
                email: '',
                link: '',
                info: '',
                category_id: this.category_id
            },
            videos: [],
            faces: [],
            categories: [],
            model_find: '',
            left_person_id: '',
            new_category_id: ''
        }
    },
    methods: {
        findname(){
            console.log('this.model_find', this.model_find);
            this.getCategoriesWithPersons();

        },
        mergePerson(){            
            
            const url = '/persons/merge',
                data = {
                    'left_person_id': this.left_person_id,
                    'right_person_id': this.right_person_id
                };

            axios.post( 
                url,
                data,
                {
                    headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                }
            ).then((responce)=>{                
                console.log('Result merge', responce);                
                if(responce.data.success){
                    console.log('Merge success');
                    console.log('this.new_category_id', this.new_category_id);
                    
                    const new_person_id = responce.data.id_left_person;

                    this.mergeInProject();
                    
                    location.href=`/categories/${this.new_category_id}/persons/${new_person_id}`;

                } else {
                    console.log('error merge');
                    console.log(responce.data);
                }                
            }).catch(function(e){
                console.log(e);
            });            
            this.closePopup();
        },
        mergeInProject(){
            //handover faces
            //del person
        },
        closePopup(){
            bus.$emit('openpopup' , {
                open: false
            });
        },
        getCategoriesWithPersons(){
            const url = '/categories/';
            const params = {                
                additionalList: 'y',
                withoutEmpty: 'y',
                find: this.model_find
            }
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'ContentType': 'application/json'
                    }
                }
            ).then((responce)=>{                
                this.data = responce.data;                
                this.categories = responce.data;
                console.log('this.categories', this.categories);
            }).catch(function(error){
                console.log(error);
            });
        }        
    },
    mounted(){
        this.title_form = this.prop_titleform;
        if(this.person){
            this.model_person = this.person;
        };
        this.getCategoriesWithPersons();
        bus.$on('changePersonMergeTo', (data) => {
            this.left_person_id = data.left_person_id;
            this.new_category_id = data.new_category_id;
        })
    },
    components: {
        CategoryCardList
    },
    computed: {
        right_person_id(){
            return this.person.id;
        }
    }
    
}
</script>

<style scoped lang="scss">
    .input_search {
        margin-bottom: 10px;
    }
    .categoryName{
        cursor: pointer;
    }    
    .black_block{
        height: 500px;
        overflow-y: scroll;
    }
    .personMergeTo {        
        margin: 10px;
        input, label {
            cursor: pointer;
        }
    }
    .btn-close{
        margin-left: 1rem;
    }
    .colors_block{
        background: var(--color-dark70);
        padding: 1rem;
        display: flex;
        .color_radio{
            cursor: pointer;
            margin: 0 0.5rem;
        }
    }
</style>
